/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { 
  styled, 
  Box, 
  Typography, 
  TextField,
  Divider,
} from "@mui/material";

export const GlobalEmployeeSearchPage = styled('div')({
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
})

export const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'report',
})(({ report }) => ({
  gap: "20px",
  paddingBottom: report && "16px",
  marginBottom: !report && "10px",
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const StyledTypography = styled(Typography)({
  fontSize: "1.4rem",
  fontWeight: 600,
  padding: "22px 0px 10px 0px",
})

export const StyledSearchBar = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #2b4fb9 !important'
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: '25px',
  },
  '& .MuiInputBase-root':{
    borderRadius: '25px',
    height: '2.4rem',
    paddingTop: '3px',
    fontSize: '15px',
    width: '253px !important',
    backgroundColor: "white",
    marginRight: '18px',
    marginTop: '8px',
  },
})

export const StyledDivider = styled(Divider)({
  borderStyle: "solid", 
  borderWidth: "1px", 
  marginBottom: '25px',
})

export const StyledListItem = styled('li')({
  '&:hover':{
    color: '#348be5',
    cursor: 'pointer',
  },
  listStyle: "none", 
  cursor: 'pointer'
})
